import { render, staticRenderFns } from "./ListReferral.vue?vue&type=template&id=4d53cfc8&"
import script from "./ListReferral.vue?vue&type=script&lang=js&"
export * from "./ListReferral.vue?vue&type=script&lang=js&"
import style0 from "./ListReferral.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports